/** Personal symbols — shared between Inner Sanctuary and Choose artifact card */
export interface PersonalSymbol {
  id: string
  label: string
  path: string
}

export const SYMBOLS: PersonalSymbol[] = [
  { id: 'spiral',   label: 'Spiral',   path: 'M 30 50 C 30 30, 50 15, 70 30 C 85 42, 75 65, 58 68 C 44 70, 36 58, 42 48 C 47 40, 58 40, 60 50' },
  { id: 'lotus',    label: 'Lotus',    path: 'M50 70 C40 55, 30 45, 35 35 C40 25, 50 30, 50 40 C50 30, 60 25, 65 35 C70 45, 60 55, 50 70Z M50 40 C45 32, 38 28, 40 22 C42 16, 50 18, 50 28 M50 40 C55 32, 62 28, 60 22 C58 16, 50 18, 50 28' },
  { id: 'eye',      label: 'Eye',      path: 'M 20 50 Q 50 25, 80 50 Q 50 75, 20 50Z M 50 50 m -8 0 a 8 8 0 1 0 16 0 a 8 8 0 1 0 -16 0' },
  { id: 'star',     label: 'Star',     path: 'M50 20 L54 38 L72 38 L58 48 L63 66 L50 56 L37 66 L42 48 L28 38 L46 38Z' },
  { id: 'infinity', label: 'Infinity', path: 'M 25 50 C 25 38, 35 30, 45 38 C 55 46, 45 62, 55 62 C 65 62, 75 54, 75 50 C 75 46, 65 38, 55 38 C 45 38, 55 54, 45 54 C 35 54, 25 62, 25 50Z' },
  { id: 'moon',     label: 'Moon',     path: 'M 55 22 A 28 28 0 1 0 55 78 A 20 20 0 1 1 55 22Z' },
]
